<template>
  <div >
    <!--overlay div (for VIEW PROFILE) -->
    <div id="overlay" @click="close($event)" style="position: fixed; width: 100%; height: 100%; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0,0,0,0.5); z-index: 10; cursor: pointer;"/>
    <!--START View Profile Popup -->
    <div class="flex flex-col absolute bg-white shadow z-40 h-auto rounded-sm flex-no-shrink flex-no-grow pin-x mx-auto" 
    style="width: 620px; top: 5rem;">
      <!-- display flex/hidden -->
      <div class="flex flex-row justify-between mx-4 mt-2 items-center">
        <div class="mt-2 mr-2 font-semibold">{{customer.name.trim()}}'s Profile</div>
        <div class="h-6 w-6 mt-2 cursor-pointer" @click="close($event)"> <img src="../../assets/close.png"></div>
      </div>
      <!-- info is displayed below -->
      <div class="flex flex-col bg-white mx-4 mb-4 mt-4 flex-no-shrink flex-no-grow">
        <div v-if="editGeneralInfo">
          <!--START general Edit-->
          <div class="flex flex-row bg-grey-lightest pl-2 rounded-tl rounded-tr items-center text-sm h-8 flex-no-shrink flex-no-grow"> 
            General 
            <span class="h-5 w-5 mr-6 ml-auto cursor-pointer text-sm text-blue font-semibold" @click="saveGeneral('editGeneralInfo', ['blood_group', 'gender', 'date_of_birth'])">Save</span>
          </div>
          <div class="flex flex-row bg-grey-extralight text-xs text-grey-dark text-left py-2 flex-no-shrink flex-no-grow">
            <!--START age-->
            <!-- <div class="flex flex-col ml-2">
                <label class="text-xs text-grey-darker mb-1 tracking-wide" for="prescribe_drug">Age</label>
                <div class="flex flex-row">
                    <input type="number" class="w-16 h-8 p-2 mr-2 bg-white rounded-sm border border-solid border-grey text-sm text-grey-darkest focus:border-blue" style="outline: none">
                </div>
            </div> -->
            <!--END age-->
            <!--START Blood Group-->
            <div class="flex flex-row">
              <div class="flex flex-col ml-2">
                <label class="text-xs text-grey-darker mb-1 tracking-wide" for="prescribe_drug">Blood Group</label>
                <div class="flex flex-row">
                  <select v-model="customer.details.health_parameters.blood_group" class="flex appearance-none w-32 h-8 pl-2 bg-white border border-solid rounded-sm border-grey-lightest text-sm text-grey-darkest focus:border-blue" name="dosage type" style="outline: none; background-position: 6.4rem 0.5rem; background-repeat: no-repeat; background-size: 0.9rem 0.9rem">
                    <option v-for="(item, index) in blood_groups" :key="index" :value="item.id">{{item.blood_type}}</option>
                  </select>
                </div>
              </div>
              <div class="flex flex-col ml-8">
                <label class="text-xs text-grey-darker mb-1 tracking-wide" for="prescribe_drug">Gender</label>
                <div class="flex flex-row">
                  <select v-model="customer.details.gender" class="flex appearance-none w-32 h-8 pl-2 bg-white border border-solid rounded-sm border-grey-lightest text-sm text-grey-darkest focus:border-blue" name="dosage type" style="outline: none; background-position: 6.4rem 0.5rem; background-repeat: no-repeat; background-size: 0.9rem 0.9rem">
                    <option v-for="(item, index) in genders" :key="index" :value="item">{{item}}</option>
                  </select>
                </div>
              </div>
              <div class="flex flex-col ml-8">
                <label class="text-xs text-grey-darker mb-1 tracking-wide" for="prescribe_drug">Date of birth</label>
                <div class="flex flex-row">
                  <date-picker v-model="customer.details.date_of_birth" format="dd/MM/yyyy" input-class="w-32 h-8 text-sm tracking-wider pl-2 cursor-auto rounded-sm border text-grey-darkest"/>
                </div>
              </div>
            </div>
            <!--END Blood Group-->
          </div>
          <!--END general Edit-->
        </div>
        <div v-else>
          <!--START general View-->
          <div class="flex flex-row bg-grey-lightest pl-2 rounded-tl rounded-tr items-center text-sm h-8 flex-no-shrink flex-no-grow"> 
            General 
            <span class="h-5 w-5 mr-4 ml-auto cursor-pointer text-sm text-blue font-semibold" @click="edit('editGeneralInfo')">Edit</span>
          </div>
          <div class="flex flex-row pl-2 bg-grey-extralight text-xs text-grey-dark text-left p-2 flex-no-shrink flex-no-grow">
            <div class="flex flex-col w-1/5">
              <div class="pb-1">Age</div>
              <div class="pb-1">Gender</div>
              <div class="pb-1">Blood Group</div>
              <div>Mobile Number</div>
            </div>
            <div class="flex flex-col w-4/5 text-grey-darkest">
              <div class="pb-1">{{dateToAge}}</div>
              <div class="pb-1">{{gender}}</div>
              <div class="pb-1">{{bloodGroup}}</div>
              <div>{{contactNumber}}</div>
            </div>
          </div>
          <!--END general View-->
        </div>
        <div v-if="editBMI">
          <!--START BMI Edit-->
          <div class="flex flex-row bg-grey-lightest pl-2 mt-4 rounded-tl rounded-tr items-center text-sm h-8 flex-no-shrink flex-no-grow"> 
            BMI (Body Mass Index)
            <span class="h-5 w-5 mr-6 ml-auto cursor-pointer text-sm text-blue font-semibold" @click="save('editBMI', ['feet', 'inches', 'weight'])">Save</span>
          </div>
          <div class="flex flex-row bg-grey-extralight text-xs text-grey-dark text-left py-2 flex-no-shrink flex-no-grow">
            <!--START height feet-->
            <div class="flex flex-col ml-2 mr-4">
            <label class="text-xs text-grey-darker mb-1 tracking-wide" for="prescribe_drug">Height</label>
            <div class="flex flex-row">
              <input v-model="customer.details.health_parameters.feet" type="number"  min="0" class="w-16 h-8 p-2 mr-2 bg-white rounded-sm border border-solid border-grey-lightest text-sm text-grey-darkest focus:border-blue" style="outline: none">
              <div class=" text-grey-darker font-light self-center"> feet </div>
            </div>
            </div>
            <!--END height feet-->

            <!--START height inches -->
            <div class="flex flex-col ml-2 mt-4">
            <div class="flex flex-row">
              <input v-model="customer.details.health_parameters.inches" type="number"  min="0" class="w-16 h-8 p-2 mr-2 bg-white rounded-sm border border-solid border-grey-lightest text-sm text-grey-darkest focus:border-blue" style="outline: none">
              <div class=" text-grey-darker font-light self-center"> inches </div>
            </div>
            </div>
            <!--END height inches-->

            <!--START Weight-->
            <div class="flex flex-col ml-2 ml-16">
            <label class="text-xs text-grey-darker mb-1 tracking-wide" for="prescribe_drug">Weight</label>
            <div class="flex flex-row">
              <input v-model="customer.details.health_parameters.weight" type="number"  min="0" class="w-16 h-8 p-2 mr-2 bg-white rounded-sm border border-solid border-grey-lightest text-sm text-grey-darkest focus:border-blue" style="outline: none">
              <div class=" text-grey-darker font-light self-center"> kg </div>
            </div>
            </div>
            <!--END weight-->
          </div>
          <!--END BMI Edit-->
        </div>
        <div v-else>
          <!-- START BMI view-->
          <div class="flex flex-row bg-grey-lightest pl-2 mt-4 rounded-tl rounded-tr items-center text-sm h-8 flex-no-shrink flex-no-grow"> 
            BMI (Body Mass Index) 
            <span class="h-5 w-5 mr-4 ml-auto cursor-pointer text-sm font-semibold text-blue" @click="edit('editBMI')">Edit</span>
          </div>
          <div class="flex flex-row pl-2 bg-grey-extralight text-xs text-grey-dark text-left p-2 flex-no-shrink flex-no-grow">
            <div class="flex flex-col w-1/5">
              <div class="pb-1">Height</div>
              <div class="pb-1">Weight</div>
              <div>BMI</div>
            </div>
            <div class="flex flex-col w-4/5 text-grey-darkest">
              <div class="pb-1">{{feet}} ft {{inches}} inches</div>
              <div class="pb-1">{{weight}} kg</div>
              <div>{{bmi}}</div>
            </div>
          </div>
          <!-- END BMI View-->
        </div>
        <div v-if="editBP">
          <!--START BP Edit-->
          <div class="flex flex-row bg-grey-lightest pl-2 mt-4 rounded-tl rounded-tr items-center text-sm h-8 flex-no-shrink flex-no-grow"> 
            BP (Blood Pressure) 
            <span class="h-5 w-5 mr-6 ml-auto cursor-pointer text-sm text-blue font-semibold" @click="saveBP('editBP')">Save</span>
          </div>
          <div class="flex flex-row bg-grey-extralight text-xs text-grey-dark text-left py-2 flex-no-shrink flex-no-grow">
            <!--START systolic-->
            <div class="flex flex-col ml-2 mr-4">
            <label class="text-xs text-grey-darker mb-1 tracking-wide" for="prescribe_drug">Systolic</label>
            <div class="flex flex-row">
              <input v-model="customer.details.health_parameters.blood_pressure.systolic" type="number"  min="0" class="w-16 h-8 p-2 mr-2 bg-white rounded-sm border border-solid border-grey-lightest text-sm text-grey-darkest focus:border-blue" style="outline: none">
              <div class=" text-grey-darker font-light self-center"> mmHg </div>
            </div>
            </div>
            <!--END systolic-->

            <!--START diastolic-->
            <div class="flex flex-col ml-2 ml-12">
            <label class="text-xs text-grey-darker mb-1 tracking-wide" for="prescribe_drug">Diastolic</label>
            <div class="flex flex-row">
              <input v-model="customer.details.health_parameters.blood_pressure.diastolic" type="number"  min="0" class="w-16 h-8 p-2 mr-2 bg-white rounded-sm border border-solid border-grey-lightest text-sm text-grey-darkest focus:border-blue" style="outline: none">
              <div class=" text-grey-darker font-light self-center"> mmHg </div>
            </div>
            </div>
            <!--END diastolic-->
          </div>
          <!--END BP Edit-->
        </div>
        <div v-else>
          <div class="flex flex-row bg-grey-lightest pl-2 mt-4 rounded-tl rounded-tr items-center text-sm h-8 flex-no-shrink flex-no-grow"> 
            BP (Blood Pressure) 
            <span class="h-5 w-5 mr-4 ml-auto cursor-pointer text-sm font-semibold text-blue" @click="edit('editBP')">Edit</span>
          </div>
          <div class="flex flex-row pl-2 bg-grey-extralight text-xs text-grey-dark text-left p-2 flex-no-shrink flex-no-grow">
            <div class="flex flex-col w-1/5">
              <div class="pb-1">Systolic</div>
              <div>Dystolic</div>
            </div>
            <div class="flex flex-col w-4/5 text-grey-darkest">
              <div class="pb-1">{{systolic}}</div>
              <div>{{diastolic}}</div>
            </div>
          </div>
        </div>
        <div v-if="editHeart">
          <!--START Heart Edit-->
          <div class="flex flex-row bg-grey-lightest pl-2 mt-4 rounded-tl rounded-tr items-center text-sm h-8 flex-no-shrink flex-no-grow"> 
            Heart 
            <span class="h-5 w-5 mr-6 ml-auto cursor-pointer text-sm text-blue font-semibold" @click="save('editHeart', ['pulse'])">Save</span>
          </div>
          <div class="flex flex-row bg-grey-extralight text-xs text-grey-dark text-left py-2 flex-no-shrink flex-no-grow">
            <!--START systolic-->
            <div class="flex flex-col ml-2 mr-4">
            <label class="text-xs text-grey-darker mb-1 tracking-wide" for="prescribe_drug">Pulse</label>
            <div class="flex flex-row">
              <input v-model="customer.details.health_parameters.pulse" type="number"  min="0" class="w-16 h-8 p-2 mr-2 bg-white rounded-sm border border-solid border-grey-lightest text-sm text-grey-darkest focus:border-blue" style="outline: none">
              <div class=" text-grey-darker font-light self-center"> bpm </div>
            </div>
            </div>
            <!--END systolic-->
          </div>
          <!--END Heart Edit-->
        </div>
        <div v-else>
          <div class="flex flex-row bg-grey-lightest pl-2 mt-4 rounded-tl rounded-tr items-center text-sm h-8 flex-no-shrink flex-no-grow"> 
            Heart 
            <span class="h-5 w-5 mr-4 ml-auto cursor-pointer text-sm font-semibold text-blue" @click="edit('editHeart')">Edit</span>
          </div>
          <div class="flex flex-row pl-2 bg-grey-extralight text-xs text-grey-dark text-left p-2 flex-no-shrink flex-no-grow">
            <div class="flex flex-col w-1/5">
              <div>Pulse</div>
            </div>
            <div class="flex flex-col w-4/5 text-grey-darkest">
              <div>{{pulse}}</div>
            </div>
          </div>
        </div>
      </div>
      <!--END View Profile Popup-->
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import DatePicker from 'vuejs-datepicker'
import _ from 'lodash'
import moment from 'moment'
export default {
  props: [''],
  components: {
    DatePicker
  },
  data () {
    return {
      blood_groups: [
        {'id': 1, 'blood_type': 'A+'},
        {'id': 2, 'blood_type': 'A-'},
        {'id': 3, 'blood_type': 'B+'},
        {'id': 4, 'blood_type': 'B-'},
        {'id': 5, 'blood_type': 'AB+'},
        {'id': 6, 'blood_type': 'AB-'},
        {'id': 7, 'blood_type': 'O+'},
        {'id': 8, 'blood_type': 'O-'}
      ],
      genders: [
        'Male',
        'Female',
        'Non-binary'
      ],
      editGeneralInfo: false,
      editBMI: false,
      editBP: false,
      editHeart: false
      // customer: {}
    }
  },
  computed: {
    ...mapGetters({
      currentCustomer: 'configuration/getActivePatientProfile',
      activeSection: 'configuration/getActiveSection'
    }),
    ...mapState({
      activeMiniMenu: state => state.configuration.activeMiniMenu
    }),
    customer: function () {
      let patient = _.cloneDeep(this.currentCustomer)
      return patient
    },
    dateToAge: function () {
      const dateOfBirth = moment(this.customer.details.date_of_birth, ['YYYY-MM-DD', 'DD/MM/YYYY'], true)
      if (!dateOfBirth.isValid()) return 'NA'

      const now = moment()
      const years = now.diff(dateOfBirth, 'years')
      const months = now.diff(dateOfBirth.add(years, 'years'), 'months')
      return `${years} Years ${months} Months`
    },
    gender: function () {
      if (this.customer.details && this.customer.details.gender) {
        return this.customer.details.gender
      }
      return 'NA'
    },
    contactNumber: function () {
      if (this.customer.details) {
        return this.customer.details.mobile_number || this.customer.details.alternative_mobile_number || 'NA'
      }
      return 'NA'
    },
    bloodGroup: function () {
      if (this.customer && this.customer.details && this.customer.details.health_parameters.blood_group !== null) {
        var length = this.blood_groups.length
        for (var i = 0; i < length; i++) {
          if (this.blood_groups[i].id === parseInt(this.customer.details.health_parameters.blood_group)) {
            return this.blood_groups[i].blood_type
          }
        }
        return 'NA'
      }
    },
    feet: function (carry = 0) {
      if (this.customer.details && this.customer.details.health_parameters && this.customer.details.health_parameters.feet) {
        return this.customer.details.health_parameters.feet
      }
      return 0
    },
    inches: function () {
      if (this.customer.details && this.customer.details.health_parameters && this.customer.details.health_parameters.inches) {
        return this.customer.details.health_parameters.inches
      }
      return 0
    },
    weight: function () {
      if (this.customer.details && this.customer.details.health_parameters && this.customer.details.health_parameters.weight) {
        return this.customer.details.health_parameters.weight
      }
      return 0
    },
    bmi: function () {
      if (this.customer.details && this.customer.details.health_parameters) {
        let height = 0
        let weight = 0
        let heightInFeet = 0
        let heightInInches = 0
        if (this.customer.details.health_parameters.feet) {
          heightInFeet = Number(this.customer.details.health_parameters.feet) * 12
        }
        if (this.customer.details.health_parameters.inches) {
          heightInInches = Number(this.customer.details.health_parameters.inches)
        }
        height = heightInFeet + heightInInches
        if (this.customer.details.health_parameters.weight) {
          weight = Number(this.customer.details.health_parameters.weight)
        }
        if (height > 0) {
          height = height * 0.0254
          let bmi = weight / (height * height)
          return bmi.toFixed(2)
        }
        return 'NA'
      }
    },
    diastolic: function () {
      if (this.customer.details && this.customer.details.health_parameters && this.customer.details.health_parameters.blood_pressure && this.customer.details.health_parameters.blood_pressure.diastolic) {
        return this.customer.details.health_parameters.blood_pressure.diastolic + ' mmHg'
      }
      return 'NA'
    },
    systolic: function () {
      if (this.customer.details && this.customer.details.health_parameters && this.customer.details.health_parameters.blood_pressure && this.customer.details.health_parameters.blood_pressure.systolic) {
        return this.customer.details.health_parameters.blood_pressure.systolic + ' mmHg'
      }
      return 'NA'
    },
    pulse: function () {
      if (this.customer.details && this.customer.details.health_parameters && this.customer.details.health_parameters.pulse) {
        return this.customer.details.health_parameters.pulse + ' bpm'
      }
      return 'NA'
    }
  },
  methods: {
    close: function (e) {
      this.$emit('viewCustomerProfile', e)
    },
    edit: function (item) {
      this[item] = true
    },
    getBloodGroupbyId: function () {
      if (this.customer && this.customer.details && this.customer.details.health_parameters.blood_group !== null) {
        var length = this.blood_groups.length
        for (var i = 0; i < length; i++) {
          if (this.blood_groups[i].id === this.customer.details.health_parameters.blood_group) {
            return this.blood_groups[i].blood_type
          }
        }
        return 'NA'
      }
    },
    validateHealthParameters: function (parameters) {
      for (const key in parameters) {
        if (parameters[key] < 0) {
          return false
        }
      }
      return true
    },
    save: function (item, keys) {
      let data = {}
      let healthParameters = this.customer.details.health_parameters
      keys.map(function (key) {
        data[key] = healthParameters[key]
      })
      // Validate data before saving
      if (!this.validateHealthParameters(data)) {
        this.$toast.open({
          message: 'Please ensure all numeric values are non-negative.',
          type: 'warning',
          position: 'top',
          queue: false
        })
        return
      }

      this[item] = false
      this.dispatchMethod(data, 'health')
    },
    saveBP: function (item) {
      let data = {
        blood_pressure: {
          diastolic: this.customer.details.health_parameters.blood_pressure.diastolic,
          systolic: this.customer.details.health_parameters.blood_pressure.systolic
        }
      }
      // Validate data before saving
      if (!this.validateHealthParameters(data.blood_pressure)) {
        this.$toast.open({
          message: 'Please ensure all numeric values are non-negative.',
          type: 'warning',
          position: 'top',
          queue: false
        })
        return
      }

      this[item] = false
      this.dispatchMethod(data, 'health')
    },
    saveGeneral: function (item, keys) {
      let data = {
        blood_group: this.customer.details.health_parameters.blood_group,
        gender: this.customer.details.gender,
        date_of_birth: this.customer.details.date_of_birth
      }
      this[item] = false
      this.dispatchMethod(data, 'general')
    },
    dispatchMethod: function (data, type) {
      if (this.activeMiniMenu === 'Chat') {
        if (this.activeSection === 'connected') {
          if (type === 'general') {
            this.$store.dispatch('consultation/updateGeneralParameters', data)
          } else {
            this.$store.dispatch('consultation/updateHealthParameters', data)
          }
        } else if (this.activeSection === 'consults') {
          if (type === 'general') {
            this.$store.dispatch('pastConsultation/updateGeneralParameters', data)
          } else {
            this.$store.dispatch('pastConsultation/updateHealthParameters', data)
          }
        }
      } else if (this.activeMiniMenu === 'OfflineConsults') {
        if (this.activeSection === 'connected') {
          if (type === 'general') {
            this.$store.dispatch('offlineConsultation/updateGeneralParameters', data)
          } else {
            this.$store.dispatch('offlineConsultation/updateHealthParameters', data)
          }
        }
      }
    }
  }
}

</script>

<style scoped>
  
</style>



// WEBPACK FOOTER //
// src/components/Customer/CustomerProfile.vue